import { Helmet } from 'react-helmet';
import {
  Box,
  Container,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Grid,
  TextField,
  Typography,
  Button,
  Modal,
} from "@material-ui/core";
import UserblockListResults from "src/components/userblock/userblocklist";
import { makeStyles } from "@material-ui/core/styles";
import React, { useState } from "react";
import axios from "axios";
import "./style.scss";
import {
  SEARCH_ACCOUNT_BLOCK,
  SEARCH_ACCOUNT_KEY_BLOCK,
  BLOCK_ACCOUNT_API,
  SEARCH_ACCOUNT_KEY,
  SEARCH_ITEMID_API,
} from "../../apiContants";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
    fontSize: "20px",
  },
  blocked: {
    position: "relative",
    right: "0px",
  },
  options: {
    width: "120px!important",
  },
  mui: {
    border: "1px!important",
    color: "red!important",
    paddingTop: "15px!important",
    paddingLeft: "0px!important",
    justifyContent: "flex-start",
    display: "flex",
  },
  mui1: {
    border: "1px!important",
    color: "red!important",
    paddingTop: "15px!important",
    paddingLeft: "0px!important",
    justifyContent: "flex-start",
    display: "flex",
    paddingLeft: "20px!important",
  },
}));
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
};

const Userblock = () => {
  const classes = useStyles();
  const [listUserLock, setListUserLock] = useState([]);
  const [regid, regidSet] = useState(Array);
  const [value, setValues] = React.useState({
    address: "",
    id: "",
  });
  const [addressId, setAddressId] = useState(null);
  const [alertBlock, setAlertBlock] = useState(null);
  const [openAlert, setOpenAlert] = useState(false);
  const [alert, setAlert] = useState(null);

  const handleChangeForm = (address) => (event) => {
    setValues({ ...value, [address]: event.target.value });
    setAddressId(null);
    if (event.target?.value) {
      setAlertBlock(null);
    }
  };

  const search = async () => {
    setListUserLock([]);
    let WalletAddress = await axios.get(SEARCH_ACCOUNT_BLOCK);
    let datas = [];
    if (!value.address && !value.id) {
      datas = WalletAddress.data.accounts;
      setListUserLock(datas);
    }
    if (value.address && !value.id) {
      datas = WalletAddress.data.accounts;
      datas = datas?.filter((x) => x.address === value.address);
      setListUserLock(datas);
      //setAddressId(datas && datas.length > 0 ? datas[0].address : null);
    } else if (!value.address && value.id) {
      const GetID = await axios.get(SEARCH_ITEMID_API + value.id);

      if (GetID?.data?.id) {
        setAddressId(GetID?.id);
        datas = WalletAddress.data.accounts;
        datas = datas?.filter((x) => x.address === GetID?.creator_acc?.address);
        setListUserLock(datas);
      }
    }
    if (value.address && value.id) {
      const GetID = await axios.get(SEARCH_ITEMID_API + value.id);

      if (GetID?.data?.id) {
        setAddressId(GetID?.id);
        datas = WalletAddress.data.accounts;
        datas = datas?.filter(
          (x) =>
            x.address === GetID?.creator_acc?.address &&
            x.address === value.address
        );
        setListUserLock(datas);
      }
    }
  };

  const Blocked = async () => {
    setAlertBlock(null);
    if (addressId) {
      const WalletAddressBlock = await axios.put(BLOCK_ACCOUNT_API + addressId);
      const datasBlock = WalletAddressBlock.data;
      if (datasBlock) {
        setOpenAlert(true);
      }
    } else {
      // else if (value.address && !value.id) {
      //   // const WalletAddress = await axios.get(
      //   //   SEARCH_ACCOUNT_KEY + value.address
      //   // );
      //   // const datas = WalletAddress.data.accounts;
      //   // const addressIdBlock =
      //   //   datas && datas.length > 0 ? datas[0].address : null;
      //   // setAddressId(addressIdBlock);
      //   const WalletAddressBlock = await axios.put(
      //     BLOCK_ACCOUNT_API + value.address
      //   );
      //   const datasBlock = WalletAddressBlock.data;
      //   setOpenAlert(true);
      //   if (datasBlock?.address) {
      //     setAlert("Block User Success!");
      //   } else {
      //     setAlert("Block User Error!");
      //   }
      // }
      if (!value.id) {
        setAlertBlock("Please enter Item ID to block !");
      } else if (!value.address && value.id) {
        try {
          const GetID = await axios.get(SEARCH_ITEMID_API + value.id);
          setOpenAlert(true);

          if (GetID?.data?.id) {
            const WalletAddressBlock = await axios.put(
              BLOCK_ACCOUNT_API + GetID.data.id
            );
            const datasBlock = WalletAddressBlock.data;

            if (datasBlock?.address) {
              setAlert("Block User Success!");
            } else {
              setAlert("Block User Error!");
            }
          } else {
            setAlert("ID not exist !");
          }
        } catch {
          setOpenAlert(true);
          setAlert("ID not exist !");
        }
      }
    }
  };
  const AlertNotice = (
    <>
      <Box sx={style}>
        <Typography id="modal-modal-title" variant="h6" component="h2">
          Alert
        </Typography>
        <Typography id="modal-modal-description" sx={{ mt: 2 }}>
          <span>{alert}</span>
        </Typography>
        <Typography id="modal-modal-footer" sx={{ mt: 2 }}>
          <Button
            className="cancel_button"
            color="primary"
            variant="contained"
            style={{ float: "right" }}
            onClick={() => setOpenAlert(false)}
          >
            Close
          </Button>
        </Typography>
      </Box>
    </>
  );
  return (
    <>
      <Helmet>
        <title>Settings | Material Kit</title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: "background.default",
          minHeight: "100%",
          py: 3,
        }}
      >
        <Container maxWidth="lg">
          <Card>
            <CardHeader title="User Blocked Manager" />
            <Divider />
            <CardContent>
              <Grid container spacing={3}>
                <Grid className={classes.mui} item xs={2}>
                  <span className={classes.paper}>Wallet ADD</span>
                </Grid>
                <Grid className={classes.mui} item xs={2}>
                  <TextField
                    onChange={handleChangeForm("address")}
                    className="containt"
                    placeholder="enter wallet address"
                    inputProps={{
                      min: 0,
                      style: { textAlign: "center", width: "250px" },
                    }}
                    id="standard-basic"
                  />
                </Grid>

                <Grid className={classes.mui} item xs={1}>
                  <span className={classes.paper}>Item ID</span>
                </Grid>
                <Grid className={classes.mui} item xs={2}>
                  <TextField
                    onChange={handleChangeForm("id")}
                    className="containt"
                    placeholder="enter Item ID"
                    inputProps={{
                      min: 0,
                      style: { textAlign: "center", width: "250px" },
                    }}
                    id="standard-basic"
                  />
                </Grid>

                <Grid className={classes.mui} item xs={2}>
                  <button
                    className={classes.options}
                    type="button"
                    onClick={() => search()}
                  >
                    Search
                  </button>
                </Grid>
                <Grid className={classes.mui1} item xs={2}>
                  <button
                    className={classes.options}
                    type="button"
                    onClick={() => Blocked()}
                  >
                    Blocked
                  </button>
                </Grid>
              </Grid>
              <span style={{ color: "red" }}>
                {alertBlock ? alertBlock : ""}
              </span>
            </CardContent>
          </Card>
          <Box sx={{ pt: 3 }}>
            <Divider />
            <UserblockListResults customers={listUserLock} />
          </Box>
          <Modal
            open={openAlert}
            onClose={() => setOpenAlert(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            {AlertNotice}
          </Modal>
        </Container>
      </Box>
    </>
  );
};

export default Userblock;
